export interface IIconifyIcon {
  userFriendlyName: string;
  variations: string[];
  keywords: string[];
}

const icons: IIconifyIcon[] = [
  {
    userFriendlyName: "WhatsApp",
    variations: ["dashicons:whatsapp"],
    keywords: ["whatsapp", "wpp", "zap", "zapzap", "zap zap"],
  },
  {
    userFriendlyName: "TikTok",
    variations: ["cib:tiktok"],
    keywords: ["tiktok", "tik", "tok"],
  },
  {
    userFriendlyName: "Instagram",
    variations: ["ant-design:instagram-filled"],
    keywords: ["instagram", "insta"],
  },
  {
    userFriendlyName: "Facebook",
    variations: ["bi:facebook"],
    keywords: ["facebook", "face", "fb", "book"],
  },
  {
    userFriendlyName: "Email",
    variations: ["ic:round-email"],
    keywords: ["email", "e-mail", "mail", "@", "message", "mensagem", "msg"],
  },
  {
    userFriendlyName: "Twitter",
    variations: ["entypo-social:twitter-with-circle"],
    keywords: ["twitter"],
  },
  {
    userFriendlyName: "YouTube",
    variations: ["entypo-social:youtube"],
    keywords: ["youtube", "yt", "you", "tube", "video", "vídeo"],
  },
  {
    userFriendlyName: "Phone",
    variations: ["el:phone-alt"],
    keywords: [
      "phone",
      "fone",
      "telefone",
      "celphone",
      "smartphone",
      "tel",
      "call",
      "ring",
    ],
  },
  {
    userFriendlyName: "Spotify",
    variations: ["akar-icons:spotify-fill"],
    keywords: ["spotify", "spot"],
  },
  {
    userFriendlyName: "Website",
    variations: ["majesticons:link-circle"],
    keywords: [
      "website",
      "web",
      "site",
      "url",
      "link",
      "domain",
      "domínio",
      "dominio",
    ],
  },
  {
    userFriendlyName: "LinkedIn",
    variations: ["entypo-social:linkedin-with-circle"],
    keywords: ["linkedin", "in"],
  },
  {
    userFriendlyName: "Twitch",
    variations: ["akar-icons:twitch-fill"],
    keywords: ["twitch"],
  },
  {
    userFriendlyName: "Discord",
    variations: ["akar-icons:discord-fill"],
    keywords: ["discord"],
  },
  {
    userFriendlyName: "Telegram",
    variations: ["akar-icons:telegram-fill"],
    keywords: ["telegram"],
  },
  {
    userFriendlyName: "Snapchat",
    variations: ["fa-brands:snapchat"],
    keywords: ["snapchat"],
  },
  {
    userFriendlyName: "Pinterest",
    variations: ["akar-icons:pinterest-fill"],
    keywords: ["pinterest"],
  },
  {
    userFriendlyName: "Shop",
    variations: ["el:shopping-cart-sign"],
    keywords: [
      "shop",
      "shopping",
      "loja",
      "compra",
      "compras",
      "comprar",
      "produto",
      "products",
    ],
  },
  {
    userFriendlyName: "SoundCloud",
    variations: ["akar-icons:soundcloud-fill"],
    keywords: ["soundcloud"],
  },
  {
    userFriendlyName: "Messenger",
    variations: ["bi:messenger"],
    keywords: ["messenger"],
  },
  {
    userFriendlyName: "Apple Music",
    variations: ["cib:apple-music"],
    keywords: ["apple", "music", "apple music"],
  },
  {
    userFriendlyName: "PayPal",
    variations: ["fa:paypal"],
    keywords: ["paypal"],
  },
  {
    userFriendlyName: "Line",
    variations: ["bi:line"],
    keywords: ["line"],
  },
  {
    userFriendlyName: "Amazon",
    variations: ["ant-design:amazon-circle-filled"],
    keywords: ["amazon", "amazon pay"],
  },
  {
    userFriendlyName: "Deezer",
    variations: ["bxl:deezer"],
    keywords: ["deezer"],
  },
  {
    userFriendlyName: "Behance",
    variations: [
      "ant-design:behance-circle-filled",
      "ant-design:behance-outlined",
      "ant-design:behance-square-filled",
      "logos:behance",
    ],
    keywords: ["behance"],
  },
  {
    userFriendlyName: "Tumblr",
    variations: [
      "akar-icons:tumblr-fill",
      "brandico:tumblr-rect",
      "el:tumblr",
      "entypo-social:tumblr-with-circle",
      "logos:tumblr",
    ],
    keywords: ["tumblr"],
  },
  {
    userFriendlyName: "Steam",
    variations: [
      "bi:steam",
      "fa-brands:steam-square",
      "icomoon-free:steam",
      "la:steam",
    ],
    keywords: ["steam"],
  },
  {
    userFriendlyName: "Onlyfans",
    variations: ["simple-icons:onlyfans"],
    keywords: ["xxxxxxx", "xxxxxxx"],
  },
  {
    userFriendlyName: "Google Drive",
    variations: ["uil:google-drive"],
    keywords: ["google", "drive", "google drive"],
  },
  {
    userFriendlyName: "Wattpad",
    variations: ["simple-icons:wattpad"],
    keywords: ["wattpad", "watt"],
  },
  {
    userFriendlyName: "Etsy",
    variations: ["cib:etsy"],
    keywords: ["etsy"],
  },
  {
    userFriendlyName: "Shopify",
    variations: ["bxl:shopify"],
    keywords: ["shopify", "Shop"],
  },
  {
    userFriendlyName: "Reddit",
    variations: ["akar-icons:reddit-fill"],
    keywords: ["reddit", "red"],
  },
  {
    userFriendlyName: "Viber",
    variations: ["jam:viber"],
    keywords: ["viber", "vibe"],
  },
  {
    userFriendlyName: "Goodreads",
    variations: ["cib:goodreads"],
    keywords: ["goodreads", "good", "reads"],
  },
  {
    userFriendlyName: "Skype",
    variations: ["ant-design:skype-filled"],
    keywords: ["skype", "sky"],
  },
  {
    userFriendlyName: "Medium",
    variations: ["ant-design:medium-circle-filled"],
    keywords: ["medium", "med"],
  },
  {
    userFriendlyName: "Google Play",
    variations: ["ant-design:medium-circle-filled"],
    keywords: ["google", "play", "google play"],
  },
  {
    userFriendlyName: "Vimeo",
    variations: ["entypo-social:vimeo-with-circle"],
    keywords: ["vimeo"],
  },
  {
    userFriendlyName: "Patreon",
    variations: ["cib:patreon"],
    keywords: ["patreon"],
  },
  {
    userFriendlyName: "Bandcamp",
    variations: ["fa:bandcamp"],
    keywords: ["bandcamp", "band", "camp"],
  },
  {
    userFriendlyName: "VSCO",
    variations: ["arcticons:vsco"],
    keywords: ["vsco"],
  },
  {
    userFriendlyName: "VK",
    variations: ["entypo-social:vk-with-circle"],
    keywords: ["vk"],
  },
  {
    userFriendlyName: "ApplePodcast",
    variations: ["simple-icons:applepodcasts"],
    keywords: ["applepodcasts", "apple", "podcast", "podcasts"],
  },
  {
    userFriendlyName: "WeChat",
    variations: ["ant-design:wechat-filled"],
    keywords: ["wechat", "we", "chat"],
  },
  {
    userFriendlyName: "Mixcloud",
    variations: ["cib:mixcloud", "simple-icons:mixcloud"],
    keywords: ["mixcloud", "mix", "cloud"],
  },
  {
    userFriendlyName: "AppStore",
    variations: ["ion:logo-apple-appstore"],
    keywords: ["apple", "appstore", "app", "store", "loja"],
  },
  {
    userFriendlyName: "Napster",
    variations: ["fa-brands:napster"],
    keywords: ["napster", "nap", "naps"],
  },
  {
    userFriendlyName: "Flickr",
    variations: ["ion:logo-flickr"],
    keywords: ["flickr", "flic", "flik", "fliker", "flicr"],
  },
  {
    userFriendlyName: "Ebay",
    variations: ["bxl:ebay"],
    keywords: [
      "ebay",
      "loja",
      "market place",
      "market",
      "marketplace",
      "mercado",
      "loja",
    ],
  },
  {
    userFriendlyName: "Flipboard",
    variations: ["fontisto:flipboard"],
    keywords: ["flipboard", "flip", "board"],
  },
  {
    userFriendlyName: "Last.FM",
    variations: ["el:lastfm"],
    keywords: ["lastfm", "last", "fm"],
  },
  {
    userFriendlyName: "Weibo",
    variations: ["ant-design:weibo-circle-filled"],
    keywords: ["weibo", "wei"],
  },
  {
    userFriendlyName: "Digg",
    variations: ["bx:bxl-digg", "whh:digg"],
    keywords: ["digg", "dig"],
  },
  {
    userFriendlyName: "Buy me a coffee",
    variations: ["cib:buy-me-a-coffee"],
    keywords: [
      "buy",
      "me",
      "coffee",
      "coffe",
      "cofe",
      "cofee",
      "café",
      "café",
      "buy me",
      "buy me a",
      "buy me a coffee",
      "copo",
      "cup",
    ],
  },
  {
    userFriendlyName: "Venmo",
    variations: ["bxl:venmo"],
    keywords: ["venmo"],
  },
  {
    userFriendlyName: "Zelle",
    variations: ["simple-icons:zelle"],
    keywords: ["zelle"],
  },
  {
    userFriendlyName: "Letterboxd",
    variations: ["cib:letterboxd"],
    keywords: ["letterboxd"],
  },
  {
    userFriendlyName: "Blogger",
    variations: ["cib:blogger-b"],
    keywords: ["blogger", "blog"],
  },
  {
    userFriendlyName: "Artstation",
    variations: ["cib:artstation"],
    keywords: ["artstation"],
  },
  {
    userFriendlyName: "Amazon Prime",
    variations: ["simple-icons:amazonprime"],
    keywords: ["amazon arime", "amazon", "prime"],
  },
  {
    userFriendlyName: "Google Maps",
    variations: ["mdi:google-maps"],
    keywords: [
      "google",
      "maps",
      "google maps",
      "map",
      "mapa",
      "location",
      "localization",
      "localização",
      "local",
      "coordenadas",
      "coordinates",
      "place",
      "address",
      "endereço",
    ],
  },
  {
    userFriendlyName: "Waze",
    variations: ["fa-brands:waze"],
    keywords: ["waze"],
  },
  {
    userFriendlyName: "Uber",
    variations: ["cib:uber"],
    keywords: ["uber"],
  },
  {
    userFriendlyName: "Uber Eats",
    variations: ["simple-icons:ubereats"],
    keywords: ["uber", "eats", "eat"],
  },
  {
    userFriendlyName: "Roblox",
    variations: ["simple-icons:roblox"],
    keywords: ["roblox"],
  },
  {
    userFriendlyName: "Google Podcast",
    variations: ["cib:google-podcasts"],
    keywords: ["google", "podcast", "google podcast", "podcasts"],
  },
  {
    userFriendlyName: "GitHub",
    variations: ["akar-icons:github-fill"],
    keywords: ["github", "git", "hub"],
  },
  {
    userFriendlyName: "Git",
    variations: ["mdi:git"],
    keywords: ["git"],
  },
  {
    userFriendlyName: "Redbubble",
    variations: ["bx:bxl-redbubble"],
    keywords: ["redbubble", "red", "bubble", "buble"],
  },
  {
    userFriendlyName: "Fiverr",
    variations: ["jam:fiverr"],
    keywords: ["fiverr", "five", "fiver"],
  },
  {
    userFriendlyName: "Coinbase",
    variations: ["simple-icons:coinbase"],
    keywords: ["coinbase", "coin", "base"],
  },
  {
    userFriendlyName: "Bitcoin",
    variations: ["akar-icons:bitcoin-fill"],
    keywords: [
      "bitcoin",
      "bit",
      "coin",
      "crypto",
      "currency",
      "moeda",
      "cripto",
      "criptomoeda",
    ],
  },
  {
    userFriendlyName: "Nubank",
    variations: ["simple-icons:nubank"],
    keywords: ["nubank", "nu", "bank", "banco"],
  },
  {
    userFriendlyName: "Wordpress",
    variations: ["brandico:wordpress"],
    keywords: ["wordpress", "word", "press"],
  },
  {
    userFriendlyName: "Bank",
    variations: ["fluent:building-bank-28-filled"],
    keywords: ["bank", "piggy"],
  },
  {
    userFriendlyName: "Generic Currency",
    variations: ["heroicons-solid:currency-dollar"],
    keywords: ["currency", "moeda"],
  },
  {
    userFriendlyName: "Dollar",
    variations: ["bxs:dollar-circle"],
    keywords: ["dolar", "dólar", "dollar"],
  },
  {
    userFriendlyName: "Euro",
    variations: ["ant-design:euro-circle-filled"],
    keywords: ["euro"],
  },
  {
    userFriendlyName: "Visual Studio",
    variations: ["cib:visual-studio"],
    keywords: [
      "visual",
      "studio",
      "visual studio",
      "code",
      "visual code",
      "visual studio code",
      "ide",
    ],
  },
  {
    userFriendlyName: "Notepad++",
    variations: ["simple-icons:notepadplusplus"],
    keywords: ["notepadplusplus", "notepad", "plus"],
  },
  {
    userFriendlyName: "Notepad",
    variations: ["bxs:notepad"],
    keywords: ["notepad", "note", "caderno", "papel", "paper"],
  },
  {
    userFriendlyName: "Calendar",
    variations: ["el:calendar-sign"],
    keywords: ["calendar", "calendário"],
  },
  {
    userFriendlyName: "Clock",
    variations: ["ant-design:clock-circle-filled"],
    keywords: [
      "clock",
      "relógio",
      "relogio",
      "time",
      "tempo",
      "hora",
      "horário",
      "horario",
      "timer",
    ],
  },
  {
    userFriendlyName: "Timer",
    variations: ["fluent:timer-20-filled"],
    keywords: ["timer", "cronômetro", "cronometro", "time", "tempo"],
  },
  {
    userFriendlyName: "Android",
    variations: ["raphael:android"],
    keywords: ["android"],
  },
  {
    userFriendlyName: "Upload",
    variations: ["bxs:cloud-upload"],
    keywords: ["upload", "enviar", "subir"],
  },
  {
    userFriendlyName: "Download",
    variations: ["fa:cloud-download"],
    keywords: ["download", "baixar"],
  },
  {
    userFriendlyName: "Smartphone",
    variations: ["eva:smartphone-fill"],
    keywords: ["smartphone", "celular", "cel", "phone", "telefone"],
  },
];

export default icons;
